import Layout from './layout';
import Sider from './Sider';
export { BasicProps as LayoutProps } from './layout';
export { SiderProps } from './Sider';
Layout.Sider = Sider;
export default Layout;



// WEBPACK FOOTER //
// ./components/layout/index.tsx